import { useEffect, useState } from "react";
import { Outlet, useMatches } from "react-router";
import { Banners } from "../shell/Banners";
import { CommandPalette } from "../shell/CommandPalette";
import { Footer } from "../shell/Footer";
import { Header } from "../shell/Header";
import { BottomTabBar, MobileDrawer } from "../shell/MobileNav";
import { useShellData } from "../shell/shellData";
import { ShortcutsDialog } from "../shell/ShortcutsDialog";
import { useGlobalShortcuts } from "../shell/shortcuts";
import { Sidebar } from "../shell/Sidebar";
import { ROUTES } from "../routes";

export function AppLayout() {
  const [drawer, setDrawer] = useState(false);
  const [palette, setPalette] = useState(false);
  const [shortcuts, setShortcuts] = useState(false);
  const { user } = useShellData();
  const matches = useMatches();
  const leaf = matches.at(-1)?.id;
  useGlobalShortcuts({ role: user?.role, openPalette: () => setPalette(true), openShortcuts: () => setShortcuts(true) });

  useEffect(() => {
    const title = ROUTES.find((r) => r.id === leaf)?.title;
    if (title) document.title = `${title} · ATS`;
  }, [leaf]);

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header onOpenDrawer={() => setDrawer(true)} onOpenPalette={() => setPalette(true)} />
      <Banners />
      <div className="flex flex-1">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <main id="main" tabIndex={-1} className="mx-auto w-full max-w-[1440px] flex-1 px-3 py-4 sm:px-4 md:px-6 max-md:pb-20">
            <Outlet />
          </main>
          <Footer onShortcuts={() => setShortcuts(true)} />
        </div>
      </div>
      <MobileDrawer open={drawer} onOpenChange={setDrawer} />
      <BottomTabBar onMore={() => setDrawer(true)} />
      <CommandPalette open={palette} onOpenChange={setPalette} />
      <ShortcutsDialog open={shortcuts} onOpenChange={setShortcuts} />
    </div>
  );
}
